import { render, staticRenderFns } from "./team-list.vue?vue&type=template&id=3133378f&"
import script from "./team-list.vue?vue&type=script&lang=ts&"
export * from "./team-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports